// What a secured place's page reads (docs/data-model.md section 6): the place itself from
// hub.my_secured_places() (its due date, the pay button's balance and its payment link), the
// session dates without their Zoom links from hub.my_session_dates(), the product's questions line,
// and the balance's amount, read from Stripe by stripe-prices because the hub stores no amounts.
// If Stripe can't be read, the page still shows, with the amount left out of its words. The Library
// reads the same balances (library/load.js), so the 2 share 1 ask of stripe-prices (lib/billing.js).
import { useEffect, useState } from 'react'
import { supabase, must } from '../lib/supabase.js'
import { loadBalances } from '../lib/billing.js'
import { balanceAmount } from '../lib/balance.js'
import { useMember } from '../app/member.jsx'

export function useSecuredPlace(productId) {
  const { me } = useMember()
  const personId = me.person?.id || null
  const [s, set] = useState({ status: 'loading' })
  useEffect(() => {
    let live = true
    Promise.all([
      supabase.rpc('my_secured_places').then(must),
      supabase.rpc('my_session_dates', { p_product: productId }).then(must),
      supabase.from('catalogue').select('id, questions_email').eq('id', productId).then(must),
      loadBalances(personId).catch(() => []),
    ])
      .then(([places, dates, rows, balances]) => {
        if (!live) return
        set({
          status: 'ready',
          place: (places || []).find(p => p.product_id === productId) || null,
          dates: (dates || []).filter(d => d.starts_at),
          questionsEmail: rows?.[0]?.questions_email || null,
          amount: balanceAmount(balances, productId),
        })
      })
      .catch(error => { if (live) set({ status: 'error', error }) })
    return () => { live = false }
  }, [productId, personId])
  return s
}
